export default {
  admin: 'Beheerder',
  password: {
    enterNewPassword: 'Voer een nieuw wachtwoord in',
    reenterNewPassword: 'Voer het nieuwe wachtwoord opnieuw in',
    updatePassword: 'Wachtwoord bijwerken',
    setPassword: 'Wachtwoord instellen',
    min8CharacterMessage: 'Het wachtwoord moet minimaal 8 tekens lang zijn',
    passwordSentMessage: 'Het wachtwoord is per e-mail verzonden naar {userName}.',
    generateNewPassword: 'Nieuw wachtwoord genereren',
    assignPasswordMessage:
      'Wijs een wachtwoord toe aan de gebruiker. De gebruiker moet dit wachtwoord wijzigen bij de volgende aanmelding.',
    generateSecurePassword: 'Veilig wachtwoord genereren',
    newPassword: 'Nieuw wachtwoord',
    confirmNewPassword: 'Bevestig nieuw wachtwoord',
    passwordHistory: 'Wachtwoordgeschiedenis',
    passwordUpdatedLog: 'Wachtwoord bijgewerkt door {userName} op {date}.',
    forgotPasswordLog: 'Verzoek om vergeten wachtwoord verzonden door {userName} op {date}.',
  },
};
